import { connection } from '@/api/connection'

export default {
  getCustomerFields: () => connection.get('/customers/custom-fields'),
  putCustomerFields: ({ customerFieldsData }) => connection.put('/customers/custom-fields', customerFieldsData),
  getCustomerField: ({ id }) => connection.get(`/customers/custom-fields/${id}`),
  postCustomerField: ({ customerFieldData }) => connection.post('customers/custom-fields', customerFieldData),
  putCustomerField: ({ id, customerFieldData }) => connection.put(`customers/custom-fields/${id}`, customerFieldData)
}
